const THEME_KEY = 'xpansvault.theme'

export const THEME_EVENT = 'xpansvault:theme-change'

export const getTheme = () => localStorage.getItem(THEME_KEY) || 'light'

export const setTheme = (theme) => {
  localStorage.setItem(THEME_KEY, theme)
  document.documentElement.setAttribute('data-theme', theme)
  window.dispatchEvent(new CustomEvent(THEME_EVENT, { detail: { theme } }))
}

export const initTheme = () => {
  document.documentElement.setAttribute('data-theme', getTheme())
}

export const toggleTheme = () => {
  const next = getTheme() === 'dark' ? 'light' : 'dark'
  setTheme(next)

  return next
}
